import { addCommaNumber } from './addCommaNumber'

export const nFormatter = (num: number, digits: number) => {
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'k' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' },
    ]
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
    const item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value
        })
    return item
        ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
        : '0'
}

function addZeroes(num: string) {
    const dec = num.split('.')[1]
    const len = dec && dec.length > 2 ? dec.length : 2
    return Number(num).toFixed(len)
}

export const formatNumber = (
    num: number,
    round: boolean,
    toFixed?: boolean,
    plusSign?: boolean,
    addZero?: boolean
) => {
    if (!num && num !== 0) {
        return 'N/A'
    }
    let numberToFormat = num as any
    if (round) numberToFormat = Math.ceil(numberToFormat)
    if (toFixed && !addZero)
        numberToFormat = (Math.round(numberToFormat * 100) / 100).toFixed(2)
    if (addZero) numberToFormat = addZeroes(numberToFormat?.toString())
    let signToShow = ''

    if (plusSign) {
        if (numberToFormat > 0) {
            signToShow = '+'
        }
    }

    return `${signToShow}${addCommaNumber(numberToFormat)}`
}
